import { CssBaseline, ThemeProvider } from '@mui/material';
import { useEffect, useState } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import AgentList from './scenes/agent/list';
import AgentTransaction from './scenes/agent/transaction';
import TreeView from './scenes/agent/treeView';
import AgentUpdate from './scenes/agent/update';
import Bar from './scenes/bar';
import BetLimit from './scenes/bet-limit';
import Calendar from './scenes/calendar/calendar';
import Contacts from './scenes/contacts';
import Dashboard from './scenes/dashboard';
import Enabled from './scenes/enabled';
import Error from './scenes/error';
import FAQ from './scenes/faq';
import Form from './scenes/form';
import GameEnabled from './scenes/game-enabled';
import GameVender from './scenes/gameVender';
import Geography from './scenes/geography';
import Sidebar from './scenes/global/Sidebar';
import Topbar from './scenes/global/Topbar';
import Invoices from './scenes/invoices';
import Line from './scenes/line';
import Login from './scenes/login';
import MoneyChargeHistory from './scenes/money/chargeHistory';
import MoneyDay from './scenes/money/day';
import MoneyPaymentHistory from './scenes/money/paymentHistory';
import MoneyReceiveHistory from './scenes/money/receiveHistory';
import MoneySendHistory from './scenes/money/sendHistory';
import My from './scenes/my';
import Pie from './scenes/pie';
import Seamless from './scenes/seamless';
import StatisticAgent from './scenes/statistic/agent';
import StatisticAgentDetail from './scenes/statistic/agent/detail';
import StatisticEachVendor from './scenes/statistic/eachVender';
import StatisticUser from './scenes/statistic/user';
import StatisticUserDetail from './scenes/statistic/user/detail';
import StatisticVendor from './scenes/statistic/vendor';
import Team from './scenes/team';
import Transfer from './scenes/transfer';
import UserBet from './scenes/user/bet';
import UserList from './scenes/user/list';
import UserDetail from './scenes/user/list/detail';
import UserMoney from './scenes/user/money';
import Transaction from './scenes/user/transaction';
import WinLimit from './scenes/win-limit';
import { getToken, removeToken, removeUser } from './services/authService'; // 경로는 실제 파일 위치에 맞게 조정
import RequireAuth from './services/requireAuth';
import { ColorModeContext, useMode } from './theme';
import axios from './utils/axiosInstance';
function App() {
  const navigate = useNavigate();
  const location = useLocation(); // 현재 경로 확인을 위한 useLocation 사용

  useEffect(() => {
    const token = getToken();
    const isLoginPage = location.pathname === '/login';

    // 로그인 페이지일 때 토큰 있으면 홈으로
    if (isLoginPage && token) {
      navigate('/', { replace: true });
      return;
    }

    // 로그인 페이지가 아닐 경우, 토큰 유효성 검사
    if (!isLoginPage && token) {
      const checkToken = async () => {
        try {
          // 로그인 페이지일 때 토큰 있으면 홈으로 이동

          await axios.post('/agent/me');
        } catch (error) {
          alert('로그인이 만료되었습니다. 다시 로그인해주세요.');
          removeToken();
          removeUser();
          navigate('/login', { replace: true });
        }
      };

      checkToken();
    }
  }, [location, navigate]);

  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);

  const isLoginPage = location.pathname === '/login'; // 로그인 페이지 확인

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          {!isLoginPage && <Sidebar isSidebar={isSidebar} />} {/* 로그인 페이지가 아니면 사이드바 렌더링 */}
          <main
            className="content"
            style={
              {
                // background: "url('../main_bg.png') no-repeat center center",
                // backgroundSize: "cover",
                // width: "100%",
                // overflow: "hidden" ,
              }
            }
          >
            {!isLoginPage && <Topbar setIsSidebar={setIsSidebar} />} {/* 로그인 페이지가 아니면 탑바 렌더링 */}
            <Routes>
              <Route path="/login" element={<Login />} />

              {/* 로그인 필요 없는 경로만 위에 두고 나머지는 RequireAuth로 감쌈 */}
              <Route
                path="/*"
                element={
                  <RequireAuth>
                    <Routes>
                      <Route path="/" element={<Dashboard />} />
                      <Route path="/team" element={<Team />} />
                      <Route path="/contacts" element={<Contacts />} />
                      <Route path="/invoices" element={<Invoices />} />
                      <Route path="/form" element={<Form />} />
                      <Route path="/bar" element={<Bar />} />
                      <Route path="/pie" element={<Pie />} />
                      <Route path="/line" element={<Line />} />
                      <Route path="/faq" element={<FAQ />} />
                      <Route path="/calendar" element={<Calendar />} />
                      <Route path="/geography" element={<Geography />} />
                      <Route path="/transfer" element={<Transfer />} />
                      <Route path="/seamless" element={<Seamless />} />
                      <Route path="/error" element={<Error />} />
                      <Route path="/my" element={<My />} />
                      <Route path="/bet-limit" element={<BetLimit />} />
                      <Route path="/win-limit" element={<WinLimit />} />
                      <Route path="/enabled" element={<Enabled />} />
                      <Route path="/game-enabled" element={<GameEnabled />} />
                      <Route path="/user-bet" element={<UserBet />} />
                      <Route path="/transaction" element={<Transaction />} />
                      <Route path="/money" element={<UserMoney />} />
                      <Route path="/user-list" element={<UserList />} />
                      <Route path="/user-detail/:id" element={<UserDetail />} />
                      <Route path="/agent-transaction" element={<AgentTransaction />} />
                      <Route path="/agent-list" element={<AgentList />} />
                      <Route path="/agent/treeview/:id" element={<TreeView />} />
                      <Route path="/agent/update/:id" element={<AgentUpdate />} />
                      <Route path="/statistic-agent" element={<StatisticAgent />} />
                      <Route path="/statistic-agent-detail/:id" element={<StatisticAgentDetail />} />
                      <Route path="/statistic-vender" element={<StatisticVendor />} />
                      <Route path="/statistic-each-vender" element={<StatisticEachVendor />} />
                      <Route path="/statistic-user" element={<StatisticUser />} />
                      <Route path="/statistic-user-detail/:id" element={<StatisticUserDetail />} />
                      <Route path="/money-day" element={<MoneyDay />} />
                      <Route path="/money-charge-history" element={<MoneyChargeHistory />} />
                      <Route path="/money-send-history" element={<MoneySendHistory />} />
                      <Route path="/money-reveive-history" element={<MoneyReceiveHistory />} />
                      <Route path="/money-payment-history" element={<MoneyPaymentHistory />} />
                      <Route path="/game-vender" element={<GameVender />} />
                    </Routes>
                  </RequireAuth>
                }
              />
            </Routes>
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
